import { Typeahead } from "react-bootstrap-typeahead";

export function IntermediarySelector({ intermediaries, onChange, value }) {

    const selectIntermediary = (value) => {
        if (value.length) {
            onChange(value[0].invoicingId);
        } else {
            onChange(null);
        }
    }

    const selectedIntermediary = intermediaries.find(x => x.invoicingId === value);
    
    const attributes = {
        id: `intermediary-selector`,
        labelKey: option => `${option.name + " - " + option.invoicingId}`,
        options: intermediaries,
        placeholder: "Välj förmedlare/partner...",
        className: "form-group px-0 mb-0",
        onChange: (selected) => selectIntermediary(selected),
        selected: selectedIntermediary ? [selectedIntermediary] : []
    };

    return <Typeahead {...attributes} />
}